var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role === 'Staff Administrador' || _vm.role === 'Staff Usuario')?_c('DashboardStaff'):(_vm.role === 'Cliente Administrador' || _vm.role === 'Cliente Usuario')?_c('DashboardClients'):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }